import React, { useEffect, useState } from 'react'
import { NFTDetailItem, NFTDetailItemMeta, NFTDetailItemWrapper } from '../../../components/NFTDetail/syled'
import NFTCategoryButton from '../../../components/NFTCategoryButton'
import Api from '../../../../../services/Api'
import CategoryList from '../../../data/NFTCategoryList'
import INFTCategory from '../../../models/INFTCategory'
import { MARKET_PLACE_ADDRESS, YTS, ZERO_ADDRESS } from '../../../../../constants'
import { useActiveWeb3React } from '../../../../../hooks'
import { ChainId, JSBI, TokenAmount } from '@yetiswap/sdk'
import { useApproveCallback } from '../../../../../hooks/useApproveCallback'
import {
  useBuyNFTToken,
  useGetSaleTokenItem,
  useGetNFTPrice,
  useGetTokenUri,
  useBuyNFTTokenWithAvax
} from '../../../../../hooks/useNFTMarketPlace'
import NFTCardButtons from '../../Default/components/NFTCardButtons/NFTCardButtons'
import NFTRemoveModal from '../../../components/NFTRemoveModal'
import { NavLink, Redirect } from 'react-router-dom'
import { getSaleToken, getWalletAddress } from '../../../utils/NFTFormatedData'
import { useGetCreatorFeeRate, useGetCreators } from '../../../../../hooks/useYetiSwapNFTCollection'
import { IDefaultCard } from '../../Default/Card/IDefaultCard'
import NFTProperty from '../../../components/NFTProperty'
import INFTProperties from '../../../models/INFTProperties'
import NFTPriceSymbol from '../../../components/NFTPriceSymbol'
import { useAddPopup } from '../../../../../state/application/hooks'
import { NFTBuyCallBackHandle } from '../../../utils/NFTErrorHandleHelper'
import NFTUrl from '../../../components/NFTUrl'
import NFTDetailActions from '../../../components/NFTDetailActions'
import { IBaseDetail } from './IBaseDetail'
import { CheckCircle } from 'react-feather'

export default function BaseDetail({
  tokenItem,
  collection,
  account,
  children,
  properites,
  description,
  officalCollection
}: IBaseDetail) {
  const activeWeb3 = useActiveWeb3React()
  const { chainId } = activeWeb3
  const saleToken = getSaleToken(tokenItem, chainId)
  const tokenID = tokenItem?.tokenId
  const [detailTokenItem, setDetailTokenItem] = useState<IDefaultCard | null>(null)
  const [buyOrRemove, setBuyOrRemove] = useState(false)
  const yts = chainId !== undefined ? YTS[chainId] : YTS[ChainId.FUJI]
  const [removeModalIsOpen, setRemoveModalIsOpen] = useState(false)
  const tokenUri = useGetTokenUri(collection.tokenAddress, tokenID)
  const NFTTokenPrice: string = useGetNFTPrice(tokenItem?.price, yts)
  const saleTokenItem = useGetSaleTokenItem(saleToken)
  const userAccountAddress = activeWeb3.account ? activeWeb3.account.toLowerCase() : ''
  const ownerWalletAddress =
    tokenItem && tokenItem.seller.toLowerCase() !== userAccountAddress ? tokenItem.seller : 'wallet'

  const tokenCreators = useGetCreators(tokenID)
  const creatorWalletAddress = tokenCreators.toLowerCase() !== userAccountAddress ? tokenCreators : 'wallet'

  const tokenRoyalities = useGetCreatorFeeRate(tokenID)

  const addPopup = useAddPopup()
  const { buyNFTCallback } = useBuyNFTToken(tokenItem?.saleIndex)
  const { buyNFTCallbackAvax } = useBuyNFTTokenWithAvax(
    tokenItem?.saleIndex,
    JSBI.BigInt(tokenItem && tokenItem.price ? tokenItem?.price : 0).toString()
  )

  useEffect(() => {
    if (tokenUri) {
      Api.get(tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenUri])

  const tokenName = detailTokenItem ? detailTokenItem.name : ''
  const category: INFTCategory | undefined = CategoryList.find(
    (categoryItem: INFTCategory) =>
      categoryItem.id === parseInt(tokenItem && tokenItem.category ? tokenItem?.category : '0', 0)
  )

  const [approvalA, approveACallback] = useApproveCallback(
    new TokenAmount(yts, JSBI.BigInt(tokenItem && tokenItem.price ? tokenItem?.price : 0)),
    chainId ? MARKET_PLACE_ADDRESS[chainId] : undefined
  )

  function cancelRemoveModal() {
    setRemoveModalIsOpen(false)
  }

  function showRemoveModal() {
    setRemoveModalIsOpen(true)
  }

  function getNFTDescription() {
    let resultDescription = null

    if (description) {
      resultDescription = <div>{description}</div>
    } else if (detailTokenItem && detailTokenItem.description) {
      resultDescription = <div>{detailTokenItem.description}</div>
    }

    return resultDescription && <div className="description">Description : {resultDescription}</div>
  }

  function getNFTProperties() {
    let resultProps: INFTProperties[] = []

    if (detailTokenItem && properites) {
      resultProps = properites
    } else if (detailTokenItem && detailTokenItem.attributes) {
      resultProps = detailTokenItem.attributes
    }

    return (
      <div className="properties">
        {detailTokenItem && detailTokenItem.externalUrl && (
          <NFTUrl key={`EXTERNAL_URL`} type={'External Url'} name={detailTokenItem.externalUrl} />
        )}
        {resultProps
          .filter((attrItem: INFTProperties) => attrItem.value)
          .map((attrItem: INFTProperties) => {
            return <NFTProperty key={`${attrItem.key}_TRAIT_TYPE`} type={attrItem.key} name={attrItem.value} />
          })}
      </div>
    )
  }

  function buyNowFunction() {
    if (tokenItem?.saleToken !== ZERO_ADDRESS) {
      if (buyNFTCallback) {
        buyNFTCallback()
          .then((r: any) => {
            if (r && r.code !== 4001) {
              setTimeout(() => setBuyOrRemove(true), 2000)
            }
          })
          .catch((e: any) => {
            console.log(e)
            const result = NFTBuyCallBackHandle(e, false)
            addPopup(result, '')
          })
      }
    } else {
      if (buyNFTCallbackAvax) {
        buyNFTCallbackAvax()
          .then((r: any) => {
            if (r && r.code !== 4001) {
              setTimeout(() => setBuyOrRemove(true), 2000)
            }
          })
          .catch((e: any) => {
            const result = NFTBuyCallBackHandle(e, false)
            console.log(e)
            addPopup(result, '')
          })
      }
    }
  }

  return (
    <NFTDetailItemWrapper>
      <NFTDetailItem>{children}</NFTDetailItem>
      <NFTDetailItemMeta>
        <div className="meta-details">
          {officalCollection !== false && (
            <div className="collection-link" title={`${collection.name} Official Collection`}>
              {collection.name} <CheckCircle width="1rem" />
            </div>
          )}
          <div className="detail-head">
            <div className="title">{tokenName}</div>
            <NFTDetailActions tokenPrice={NFTTokenPrice} seller={ownerWalletAddress} creator={creatorWalletAddress} />
          </div>
          {category && (
            <div className="category">
              <NFTCategoryButton text={category.name} />
            </div>
          )}
          {NFTTokenPrice !== '0' && (
            <div className="price">
              {NFTTokenPrice} <NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />
            </div>
          )}
          <div className="owner">
            Owned by{' '}
            <span>
              {tokenItem ? (
                <NavLink to={`/profile/${ownerWalletAddress}?tab=on-sale`}>
                  {ownerWalletAddress === 'wallet' ? 'You' : getWalletAddress(tokenItem.seller)}
                </NavLink>
              ) : (
                ''
              )}
            </span>
          </div>
          <div className="creator">
            Created by{' '}
            <span>
              {tokenItem ? (
                <NavLink to={`/profile/${creatorWalletAddress}?tab=on-sale`}>
                  {creatorWalletAddress === 'wallet' ? 'You' : getWalletAddress(creatorWalletAddress)}
                </NavLink>
              ) : (
                ''
              )}
            </span>
          </div>
          {tokenRoyalities ? (
            <div className="token-royalties">
              Royalties : <span>{tokenRoyalities}%</span>
            </div>
          ) : (
            ''
          )}
          {getNFTDescription()}
          {getNFTProperties()}
        </div>
        <NFTCardButtons
          tokenId={tokenItem?.tokenId}
          tokenContractAddress={collection.tokenAddress}
          tokenName={tokenName}
          approve={approveACallback}
          approveState={approvalA}
          buyNow={buyNowFunction}
          isSale={NFTTokenPrice !== '0'}
          token={tokenItem}
          removeSale={showRemoveModal}
          account={account}
          saleToken={saleToken}
        />
      </NFTDetailItemMeta>
      <NFTRemoveModal
        isOpen={removeModalIsOpen}
        onDismiss={cancelRemoveModal}
        tokenId={tokenItem && tokenItem.saleIndex ? tokenItem.saleIndex : 0}
        NFTName={tokenName}
        getSalesNFTItems={() => setBuyOrRemove(true)}
        key={`${tokenItem?.id}_${collection.tokenAddress}_MODAL`}
      />
      {buyOrRemove && <Redirect to={`/profile/wallet?tab=collection`} />}
    </NFTDetailItemWrapper>
  )
}
